import React from 'react';
import { Icon } from '@iconify/react';

function CourseTableCourseCell({ course }) {
    const summary = course.course_summary || {};

    return (
        <td className="tw-py-4">
            <div className="tw-flex tw-min-w-0 tw-items-center">
                <img
                    src={course.banner_image || 'default-course-image.png'}
                    alt={course.course_name}
                    className="tw-me-3 tw-h-[72px] tw-w-24 tw-shrink-0 tw-rounded-lg tw-object-cover"
                />
                <div className="tw-min-w-0 tw-flex-1">
                    <div
                        className="![font-weight:var(--font-weight-medium)] tw-mb-1 tw-max-w-[220px] tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-font-medium"
                        title={course.course_name}
                    >
                        {course.course_name}
                    </div>
                    <div className="course-table-metadata tw-grid tw-grid-cols-1 tw-gap-y-1 tw-text-xs tw-text-slate-500">
                        <span className="tw-inline-flex tw-min-w-0 tw-items-center tw-whitespace-nowrap">
                            <Icon icon="tabler:video" className="tw-me-2 tw-shrink-0" width="16" height="16" />
                            {summary.total_videos || 0} Videos
                        </span>
                        <span className="tw-inline-flex tw-min-w-0 tw-items-center tw-whitespace-nowrap">
                            <Icon icon="tabler:file-text" className="tw-me-2 tw-shrink-0" width="16" height="16" />
                            {summary.total_documents || 0} Documents
                        </span>
                        <span className="tw-inline-flex tw-min-w-0 tw-items-center tw-whitespace-nowrap">
                            <Icon icon="tabler:chart-dots" className="tw-me-2 tw-shrink-0" width="16" height="16" />
                            {summary.total_surveys || 0} Surveys
                        </span>
                        <span className="tw-inline-flex tw-min-w-0 tw-items-center tw-whitespace-nowrap">
                            <Icon icon="tabler:writing" className="tw-me-2 tw-shrink-0" width="16" height="16" />
                            {summary.total_assessments || 0} Assessments
                        </span>
                    </div>
                </div>
            </div>
        </td>
    );
}

export default CourseTableCourseCell;
